import {GraphValues} from "./GraphValues";

export class Incasso {
    totaleIncassato!: string;
    incassoList!: GraphValues[];
    totaleScontrinoMedio!: string;
    scontrinoMedioList!: GraphValues[];
    totaleCoperti!: string;
    copertiList!: GraphValues[];
    tipologiaPagamentoList!: GraphValues[];
    incassoFasciaOrariaList!: GraphValues[];
    incassoPerCategoriaList!: GraphValues[];

    static fromJson(json: any): Incasso {
        let result = new Incasso();
        result.totaleIncassato = json.totaleIncassato;
        result.totaleScontrinoMedio = json.totaleScontrinoMedio;
        result.totaleCoperti = json.totaleCoperti;

        if (json.incassoList) {
            result.incassoList = json.incassoList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.scontrinoMedioList) {
            result.scontrinoMedioList = json.scontrinoMedioList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.copertiList) {
            result.copertiList = json.copertiList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.tipologiaPagamentoList) {
            result.tipologiaPagamentoList = json.tipologiaPagamentoList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.incassoFasciaOrariaList) {
            result.incassoFasciaOrariaList = json.incassoFasciaOrariaList.map((value: any) => GraphValues.fromJson(value));
        }

        if (json.incassoPerCategoriaList) {
            result.incassoPerCategoriaList = json.incassoPerCategoriaList.map((value: any) => GraphValues.fromJson(value));
        }

        return result;
    }
}
